import React, { FC, memo } from 'react'

import { PersonInterlinksSectionTransport } from '../../../transports/region-landing-page-transport'
import { Title, TitleContainer, Subtitle } from '../common/styles'
import { Container, InnerContainer, LinkCard, ImageWrapper, LinkLabel } from './styles'
import ImageLoadingComponent from '../../app-components/image-loading-component'

interface Props {
    personInterlinksSection: PersonInterlinksSectionTransport
}

const PersonInterlinksSection: FC<Props> = ({ personInterlinksSection }) => {
    const { heading, subheading, items } = personInterlinksSection

    return (
        <Container>
            <TitleContainer>
                <Title>{heading}</Title>
                {subheading && <Subtitle>{subheading}</Subtitle>}
            </TitleContainer>
            <InnerContainer>
                {items.map(item => (
                    <LinkCard key={item.link} href={item.link}>
                        {item.image?.url && (
                            <ImageWrapper>
                                <ImageLoadingComponent
                                    src={item.image.formats?.small?.url || item.image.url}
                                    alt={item.label}
                                    objectFit="cover"
                                />
                            </ImageWrapper>
                        )}
                        <LinkLabel>{item.label}</LinkLabel>
                    </LinkCard>
                ))}
            </InnerContainer>
        </Container>
    )
}

export default memo(PersonInterlinksSection)
